import { useEffect, useState } from "react";

interface TutorialHighlightProps {
  readonly target: string;
}

export function TutorialHighlight({ target }: TutorialHighlightProps) {
  const [rect, setRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    const update = () => {
      const el = document.querySelector(`[data-tutorial="${target}"]`);
      if (el) setRect(el.getBoundingClientRect());
      else setRect(null);
    };
    update();
    const interval = setInterval(update, 300);
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);
    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
    };
  }, [target]);

  if (!rect) return null;

  const pad = 6;
  return (
    <div
      className="fixed z-[65] pointer-events-none rounded-2xl ring-2 ring-accent ring-offset-2 ring-offset-transparent animate-pulse"
      style={{
        top: rect.top - pad,
        left: rect.left - pad,
        width: rect.width + pad * 2,
        height: rect.height + pad * 2,
      }}
    />
  );
}
